import { ChangeDetectorRef, Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { AuthService } from './auth.service';

@Directive({
  selector: '[mojoAuthGuard]',
})
export class AuthGuardDirective implements OnInit, OnDestroy {
  private subscribtion: Subscription;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly changeDetection: ChangeDetectorRef,
    private readonly authService: AuthService,
  ) { }

  ngOnInit() {
    this.subscribtion = this.authService.isAuthenticated$.subscribe((isAuthenticated) => {
      this.viewContainer.clear();
      if (isAuthenticated) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
      this.changeDetection.markForCheck();
    });
  }

  ngOnDestroy() {
    this.subscribtion.unsubscribe();
  }
}
